import { sharedNonInteractiveReducer } from '../../../store/reducers/nonInteractiveReducer/sharedNonInteractiveReducer';
import { SelfPacedNonInteractiveView } from '../../store/selfPacedPlayerStore.types';
import { SelfPacedPinReducer } from '../selfPacedReducer.types';

export const nonInteractiveSelfPacedReducer: SelfPacedPinReducer<SelfPacedNonInteractiveView> = {
  phases: sharedNonInteractiveReducer.phases,
  initial: (_state, history) => sharedNonInteractiveReducer.initial(history),
  hasNextView(state, currentView, direction) {
    const pin = state.pins.find((p) => p.id === state.currentPinId);
    return sharedNonInteractiveReducer.hasNextView(pin ?? null, currentView, direction);
  },
  handleNextView(state, currentView, direction) {
    const pin = state.pins.find((p) => p.id === state.currentPinId);
    return sharedNonInteractiveReducer.handleNextView(pin ?? null, currentView, direction);
  },
};
